// @ts-nocheck
/* eslint-disable */
export const boldShareIcon = {
    data: ``,
    name: 'bold-share' as const
};